module.exports = __webpack_public_path__ + "img/6.76fb9430.png";